import { render } from "./penilaianMateri.vue?vue&type=template&id=4820358b"
import script from "./penilaianMateri.vue?vue&type=script&lang=js"
export * from "./penilaianMateri.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__